import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import SiteFooter from "./components/SiteFooter";
import UserInfo from "./components/userAuth/Userinfo";
import Yunying from "./components/yunying/yunying";

function App_yunying() {
  const [currentView, setCurrentView] = useState("yunying");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar
        currentView={currentView}
        setCurrentView={setCurrentView}
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
      
      <main className="flex-grow">
        <Routes>
          <Route path="/userinfo" element={<UserInfo />} />
          <Route path="/yunying" element={<Yunying />} />     
          <Route path="*" element={<Navigate to="/yunying" replace />} />
        </Routes>
      </main>
      
      <SiteFooter />
    </div>
  );
}

export default App_yunying;